import Axios from 'axios';
import { getPlatform } from './helpers';

const platform = getPlatform();

export default function setupInterceptor(store) {
  Axios.defaults.baseURL = platform === 'web' ? '' : 'https://app.whatsform.com';

  Axios.interceptors.request.use(
    (request) => {
      const token = store?.getState().auth.token;
      request.headers['Content-type'] = 'application/json';
      if (token) {
        request.headers['x-auth-token'] = token;
      }
      return request;
    },
    (error) => {
      return Promise.reject(error);
    },
  );
}
